import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ProfilesStore, ProfilesState } from './profiles.store';

@Injectable({ providedIn: 'root' })
export class ProfilesQuery extends QueryEntity<ProfilesState> {
  constructor(protected store: ProfilesStore) {
    super(store);
  }
}
